import { HOST } from "../constants/HostConstants";

export const advertisementReject = async (advertisement_id, reason) => {
  try {
    const response = await fetch(
      `${HOST}/api/advertisement/advertisementReject`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          advertisement_id,
          reason,
        }),
      },
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Failed to reject advertisement");
    }

    return await response.json();
  } catch (error) {
    console.error("Error rejecting ad:", error);
    throw error;
  }
};
